import React, { useEffect, useState } from 'react'
import Meta from './layout/Meta'
import '../css/manufacturing.css';
import { Link } from 'react-router-dom';
import axios from 'axios';
import helpers from '../helper';
import { Fancybox } from '@fancyapps/ui/dist/fancybox/fancybox.esm';
import Loadingpage from '../loader/Cms';

export default function Manufacturing() {
    Fancybox.bind('[data-fancybox="gallery"]', {});
    const [pageloader, setPageloader] = useState(false);
    const [pagedata, setPagedata] = useState();
    const [galleries, setGalleries] = useState([]);

    useEffect(() => {
        setPageloader(true);
        async function fetchData() {
            await axios.get(process.env.REACT_APP_API + 'api/getcmsdata/3')
                .then((response) => {
                    setPagedata(response.data.result);
                    setPageloader(false);
                });
        }
        fetchData();
    }, [setPagedata]);

    useEffect(() => {
        async function galleriesfunction() {
            await axios.get(process.env.REACT_APP_API + 'api/manufacturinggallery')
                .then((response) => {
                    setGalleries(response.data.result.data);
                });
        }
        galleriesfunction();
    }, [setGalleries]);

    return (
        <>
            <Meta id={5} />
            <main>
                <section className="InnerHead bgthm2">
                    <img loading="lazy" src={require("../assets/img/img-bg.svg").default} alt="Manufacturing" className="imgbg" width="1600" height="453" />
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8 text-center">
                                <h1 className="fw-normal text-white">Manufacturing</h1>
                                <ol className="breadcrumb m-0 justify-content-center">
                                    <li className="breadcrumb-item"><Link to="/"><img src={require("../assets/img/home.svg").default} width="14" height="14" alt="Home" /></Link></li>
                                    <li className="breadcrumb-item"><span aria-current="page">Manufacturing</span></li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>
                {
                    pageloader ?
                        <div className='container mt-5 p-3'>
                            <Loadingpage />
                        </div>
                        :
                        <>
                            {
                                pagedata ?
                                    <section className="Home">
                                        <div className="container">
                                            <div className="row justify-content-center">
                                                <div className="col-lg-9 col-md-10 text-center mb-4">
                                                    <span className="SubTitle">{pagedata.title}</span>
                                                    <h2 className="Heading">{pagedata.heading}</h2>
                                                </div>
                                                <div className="col-12 CmsPage">
                                                    {
                                                        helpers.helpers1(pagedata.image) ?
                                                            <picture className="h-auto float-md-end mb-md-5 ms-md-5 col-md-2">
                                                                <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/cms/' + pagedata.image} alt="Gallery" className="w-100" width="380" height="480" />
                                                            </picture>
                                                            :
                                                            <picture className="h-auto float-md-end mb-md-5 ms-md-5 col-md-2">
                                                                <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/cms/webp/' + pagedata.image + '.webp'} type="image/webp" />
                                                                <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/cms/avif/' + pagedata.image + '.avif'} type="image/avif" />
                                                                <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/cms/jpg/' + pagedata.image + '.jpg'} alt="Gallery" className="w-100" width="380" height="480" />
                                                            </picture>
                                                    }

                                                    <div dangerouslySetInnerHTML={{ __html: pagedata.description }} />
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                    :
                                    ''
                            }

                            {
                                galleries.length > 0 ?
                                    <section>
                                        <div className="container">
                                            <h2 className="Heading">Manufacturing Gallery</h2>
                                            <div className="row">
                                                {
                                                    galleries.map((gallery, gl) =>
                                                        <div className="col-xl-2 col-md-3 lg-sm-4 col-6" key={gl}>
                                                            {
                                                                helpers.helpers1(gallery.image) ?
                                                                    <a href={process.env.REACT_APP_API + 'uploads/manufacturing/' + gallery.image} className="gallery" data-fancybox="gallery">
                                                                        <picture>
                                                                            <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/manufacturing/' + gallery.image} alt={"Gallery " + gl} width="380" height="480" />
                                                                        </picture>
                                                                    </a>
                                                                    :
                                                                    <a href={process.env.REACT_APP_API + 'uploads/manufacturing/webp/' + gallery.image + '.webp'} className="gallery" data-fancybox="gallery">
                                                                        <picture>
                                                                            <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/manufacturing/webp/' + gallery.image + '.webp'} type="image/webp" />
                                                                            <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/manufacturing/jpg/' + gallery.image + '.jpg'} alt={"Gallery " + gl} width="380" height="480" />
                                                                        </picture>
                                                                    </a>
                                                            }
                                                        </div>
                                                    )
                                                }

                                            </div>
                                        </div>
                                    </section>
                                    :
                                    ''
                            }

                        </>
                }

            </main >
        </>
    )
}
